import { ReducerState } from "./reducers";

export function isUserLoaded(status: ReducerState) {
    return status.get("userLoaded");
}
